import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/oraya-api";
import { Field, TextInput, TextArea } from "@/admin/adminUi";

export default function AdminSettings() {
  const [s, setS] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/admin/site-settings").then(({ data }) => setS({
      contact_email: "", contact_location: "", footer_tagline: "",
      seo_default_title: "", seo_default_description: "",
      social_links: { linkedin: "", twitter: "", github: "" }, ...data,
    })).catch(() => {});
  }, []);

  const save = async () => {
    setSaving(true);
    try { await api.put("/admin/site-settings", s); toast.success("Settings saved"); }
    catch (e) { toast.error(apiError(e.response?.data?.detail)); } finally { setSaving(false); }
  };

  if (!s) return <p className="text-oraya-slate">Loading…</p>;
  const sl = s.social_links || {};

  return (
    <div className="max-w-2xl">
      <h1 className="display text-3xl font-light text-oraya-mist">Site Settings</h1>
      <p className="text-oraya-slate mt-1">Contact info, SEO defaults and footer. Brand identity is code-controlled and not editable here.</p>

      <div className="bg-oraya-graphite border border-white/[0.06] rounded-2xl p-6 mt-8 flex flex-col gap-5">
        <Field label="Contact email"><TextInput value={s.contact_email} onChange={(v) => setS({ ...s, contact_email: v })} testid="settings-contact-email" /></Field>
        <Field label="Contact location"><TextInput value={s.contact_location} onChange={(v) => setS({ ...s, contact_location: v })} testid="settings-location" /></Field>
        <Field label="Footer tagline"><TextInput value={s.footer_tagline} onChange={(v) => setS({ ...s, footer_tagline: v })} testid="settings-footer-tagline" /></Field>
        <Field label="SEO default title"><TextInput value={s.seo_default_title} onChange={(v) => setS({ ...s, seo_default_title: v })} testid="settings-seo-title" /></Field>
        <Field label="SEO default description"><TextArea rows={2} value={s.seo_default_description} onChange={(v) => setS({ ...s, seo_default_description: v })} testid="settings-seo-desc" /></Field>
        <div className="grid grid-cols-3 gap-4">
          <Field label="LinkedIn"><TextInput value={sl.linkedin} onChange={(v) => setS({ ...s, social_links: { ...sl, linkedin: v } })} testid="settings-linkedin" /></Field>
          <Field label="Twitter/X"><TextInput value={sl.twitter} onChange={(v) => setS({ ...s, social_links: { ...sl, twitter: v } })} testid="settings-twitter" /></Field>
          <Field label="GitHub"><TextInput value={sl.github} onChange={(v) => setS({ ...s, social_links: { ...sl, github: v } })} testid="settings-github" /></Field>
        </div>
        <button onClick={save} disabled={saving} data-testid="settings-save" className="self-start rounded-lg bg-oraya-mist text-oraya-black px-5 py-2.5 text-sm font-medium hover:bg-white disabled:opacity-50">
          {saving ? "Saving…" : "Save settings"}
        </button>
      </div>
    </div>
  );
}
